import { defineCustomElement } from 'vue';
import MultipleSelectFile from '../../../src/shared/MultipleSelectFile.vue';

const MultipleSelectFileElement = defineCustomElement(MultipleSelectFile, { shadowRoot: false });
customElements.define('multiple-select-file', MultipleSelectFileElement);
